import { render, staticRenderFns } from "./SocialServeChild.vue?vue&type=template&id=6190cca9&scoped=true&"
import script from "./SocialServeChild.vue?vue&type=script&lang=js&"
export * from "./SocialServeChild.vue?vue&type=script&lang=js&"
import style0 from "./SocialServeChild.vue?vue&type=style&index=0&id=6190cca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190cca9",
  null
  
)

export default component.exports